<template>
  <div class="home">
    <h1> Welcome to Posdata referential</h1>
  </div>
</template>


<script>

  export default {
    name: 'Home'

  }

</script>



// WEBPACK FOOTER //
// src/components/Home.vue